import React, { useState } from "react";
import AddButton from "ui/AddButton";
import SpillTheTeaModal from "components/Posts/SpillTheTeaModal";
import { Impact, Action, Solution, Issue, Comment } from "util/constants";

interface Props {
  buttonText?: string;
  tooltip?: string;
  className?: string;
  initialIssue?: Issue | null;
  onImpactAdded?: (item: Impact | Comment) => void;
  onSolutionAdded?: (solution: Solution) => void;
  onActionAdded?: (action: Action) => void;
  fixedPostType?: "impact" | "teabate" | "solution" | "action";
  hidePostTypeButtons?: boolean;
  teabateNavigateOnSuccess?: boolean;
  teabateRequireAlignmentDimension?: boolean;
  teabateDimensionRequiredMessage?: string;
  teabateInitialClaim?: string;
}

const PostCreateButton: React.FC<Props> = ({
  buttonText,
  tooltip = "Create a post",
  className = "",
  initialIssue = null,
  onImpactAdded,
  onSolutionAdded,
  onActionAdded,
  fixedPostType,
  hidePostTypeButtons,
  teabateNavigateOnSuccess = true,
  teabateRequireAlignmentDimension = false,
  teabateDimensionRequiredMessage,
  teabateInitialClaim,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <AddButton
        tooltipTitle={tooltip}
        buttonText={buttonText}
        onClick={() => setOpen(true)}
        className={className}
        noPlus={false}
      />
      {open && (
        <SpillTheTeaModal
          open={open}
          onClose={() => setOpen(false)}
          initialSelectedIssue={initialIssue}
          onImpactAdded={onImpactAdded}
          onSolutionAdded={onSolutionAdded}
          onActionAdded={onActionAdded}
          fixedPostType={fixedPostType}
          hidePostTypeButtons={hidePostTypeButtons}
          teabateNavigateOnSuccess={teabateNavigateOnSuccess}
          teabateRequireAlignmentDimension={teabateRequireAlignmentDimension}
          teabateDimensionRequiredMessage={teabateDimensionRequiredMessage}
          teabateInitialClaim={teabateInitialClaim}
        />
      )}
    </>
  );
};

export default PostCreateButton;


